import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../custom.css';
import logo from '../logo.svg';
import UserProfile from './UserProfile';
import axios from 'axios';
import SimpleReactValidator from 'simple-react-validator';
import { Cookies } from 'react-cookie';
import InputBoxComponent from './InputBoxComponent';
import MultiStepRegistration from './Register/MultiStepRegistration';
import LinkedInTag from 'react-linkedin-insight';
import gtag from 'ga-gtag';

const cookies = new Cookies();
const recaptchaRef = React.createRef();

interface PHomePageHeader {
	onRef?: (homePageHeader: HomePageHeader) => void;
	data: any;
	history?: Array<string>;
}

class SHomePageHeader {
	constructor() {
	}
}

class HomePageHeader extends Component<PHomePageHeader, any> {

	validator: SimpleReactValidator = null;
	loginValidator: SimpleReactValidator = null;
	OTPValidator: SimpleReactValidator = null;
	listener: any = null;
	helpers: any = null;

	constructor(props: PHomePageHeader) {
		super(props);
		this.state = {
			showLoginModal: false,
			showForgotPasswordModal: false,
			showNotificationModal: false,
			notification_data: '',
			login_email: '',
			login_password: '',
			isLoggedIn: false,
			nextURL: '',
			propertyType: '',
			propertySubType: '',
			fpEmail: '',
			showLoginSuccessModal: false,
			showLogoutSuccessModal: false,

			showRegistrationModal: false,
			fname: '',
			lname: '',
			companyName: '',
			password: '',
			confirm_password: '',
			email: '',
			showRegistrationSuccessModal: false,
			reacatpcha_value: null,
			showOTPModal: false,
			headerBackgroundColor: 'transparent'
		}
		this.handleMyListing = this.handleMyListing.bind(this);
		this.logoutUser = this.logoutUser.bind(this);
		this.checkNotification = this.checkNotification.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.checkIfLoginPage = this.checkIfLoginPage.bind(this);
		this.setLoginEmail = this.setLoginEmail.bind(this);
		this.setLoginPassword = this.setLoginPassword.bind(this);
		this.handleLogin = this.handleLogin.bind(this);

		this.validator = new SimpleReactValidator({
			validators: {
				phone: {  // name the rule
					message: 'The :phone must be a valid phone number.',
					rule: (val: any, params?: any, validator?: any) => {
						return validator.helpers.testRegex(val, /^[1]{1} \([0-9]{3}\) [0-9]{3}-[0-9]{4}$/)
					},
					messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
					required: true  // optional
				} as any
			}
		});
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.props.onRef(this);
		// change navbar color on scroll
		this.listener = document.addEventListener('scroll', e => {
			const scrolled = document.scrollingElement.scrollTop;
			if (scrolled >= 120) {
				this.setState({ headerBackgroundColor: '#0069E4' });
			} else {
				this.setState({ headerBackgroundColor: 'transparent' });
			}
		});
		if (sessionStorage.getItem('showNotificationModal')) {
			// this.setState({
			// 	showNotificationModal: localStorage.getItem('showNotificationModal')
			// })
		} else {
			let this_keyword = this
			this.checkNotification(this_keyword)
		}

	}
	checkNotification(this_keyword) {
		axios.post(process.env.REACT_APP_BASE_URL + '/api/get-notification-info', {
			id: 1
		})
			.then(function (response) {
				this_keyword.setState({
					showNotificationModal: response.data[0].is_visible == 1 ? true : false,
					notification_data: response.data[0].description_data
				});
				sessionStorage.setItem('showNotificationModal', 'not_visible');
			})
			.catch(function (error) {
			});
	}

	componentWillUnmount() {
		this.props.onRef(undefined);
	}

	componentWillMount() {
		this.loginValidator = new SimpleReactValidator({
			element: (message, className) => <div className='text-danger'>{message}</div>
		});
		this.validator = new SimpleReactValidator({
			element: (message, className) => <div className='text-danger'>{message}</div>
		});
		this.OTPValidator = new SimpleReactValidator({
			element: (message, className) => <div className='text-danger'>{message}</div>
		})
	}

	handleMyListing() {
		this.props.data.history.push('/my-listing');
	}

	logoutUser() {
		// UserProfile.forgetEmail();
		// UserProfile.forgetFirstName();
		// UserProfile.forgetLastName();
		// UserProfile.forgetUserType();
		cookies.remove('token');
		localStorage.clear();
		this.setState({ isLoggedIn: false, showLogoutSuccessModal: true });
		this.props.data.history.push('/');
	}

	handleLogoutSuccessModal = () => {
		this.setState({ showLogoutSuccessModal: false });
	}

	handleShow(nextURL, type = '', subType = '') {
		this.setState({
			nextURL: nextURL,
			propertyType: type,
			propertySubType: subType,
		});

		if (cookies.get('token') !== undefined) {
			fetch(process.env.REACT_APP_BASE_URL + '/api/checkToken', {
				headers: {
					'Content-Type': 'application/json',
					'Access-Control-Allow-Origin': process.env.REACT_APP_BASE_URL,
					'x-access-token': cookies.get('token')
				},
			})
				.then((res: { status: number }) => {
					if (res.status === 200) {
						if (nextURL === '/create-listings') {
							// this.props.data.history.push('/create');
							this.props.data.history.push({
								pathname: '/create-listings',
								state: {
									propertyType: this.state.propertyType,
									propertySubType: this.state.propertySubType,
								}
							})
						} else if (nextURL === '/view-listings') {
							// this.props.data.history.push('/listing');
							this.props.data.history.push({
								pathname: '/view-listings',
								state: {
									propertyType: type,
									propertySubType: subType,
								}
							})
						}
					} else {
						UserProfile.forgetEmail();
						cookies.remove('token');
						this.props.data.history.push('/');
						window.scrollTo(0, 0);
						// const error = new Error(res.error);
						// throw error;
					}
				})
				.catch((err) => {
					console.error(err);
					this.setState({ loading: false, redirect: true });
				});
		} else {
			this.handleOpen();
		}
	}

	handleOpen = () => {
		this.setState({ showLoginModal: true });
	}

	handleClose() {
		this.setState({ showLoginModal: false });
	}

	handleShowForgotPasswordModal = () => {
		this.setState({ showForgotPasswordModal: true });
		this.handleClose();
	}

	handleForgotPasswordClose = () => {
		this.setState({ showForgotPasswordModal: false });
		this.handleOpen();
	}
	handleNotificationModal = () => {
		this.setState({ showNotificationModal: false });
	}

	setFPEmail = (event) => {
		this.setState({ fpEmail: event.target.value });
	}

	sendFPEmail = () => {
		axios.post(process.env.REACT_APP_BASE_URL + '/api/forgot-password',
			{
				headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
				fpEmail: this.state.fpEmail
			}).then(response => {
				document.getElementById('fp_success').style.display = 'block';
				document.getElementById('fp_error').style.display = 'none';
			}).catch(function (error) {
				document.getElementById('fp_success').style.display = 'none';
				document.getElementById('fp_error').style.display = 'block';
				// alert('Something went wrong! Please try after sometime.')
			});
	}

	setLoginEmail(event) {
		this.setState({ login_email: event.target.value });
	}

	setLoginPassword(event) {
		this.setState({ login_password: event.target.value });
	}

	checkIfLoginPage() {
		if (this.props.data.location.pathname === '/register') {
			this.handleClose();
		} else {
			this.props.data.history.push({
				pathname: '/register',
				state: {
					nextURL: '/create-listings',
				}
			})
		}
	}

	handleLoginSuccessResponse = response => {
		UserProfile.setEmail(response.data.email);
		UserProfile.setFirstName(response.data.first_name);
		UserProfile.setLastName(response.data.last_name);
		UserProfile.setCompanyName(response.data.companyName);
		UserProfile.setUserType(response.data.user_type);

		this.setState({
			isLoggedIn: true,
			showLoginSuccessModal: true,
		});

		cookies.set('token', response.data.token);
		this.forceUpdate();

		if (this.props.data.location.pathname === '/register' || this.props.data.location.pathname === '/success' || this.state.nextURL === '/create-listings') {
			// this.props.data.history.push('/create');
			this.props.data.history.push({
				pathname: '/create-listings',
				state: {
					propertyType: this.state.propertyType,
					propertySubType: this.state.propertySubType,
				}
			})
		}
		else if (this.state.nextURL === '/view-listings') {
			// this.props.data.history.push('/listing');
			this.props.data.history.push({
				pathname: '/view-listings',
				state: {
					propertyType: this.state.propertyType,
					propertySubType: this.state.propertySubType,
				}
			})
		}
	}

	handleLogin() {
		if (this.loginValidator.allValid()) {
			axios.post(process.env.REACT_APP_BASE_URL + '/api/login-user',
				{
					headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
					login_email: this.state.login_email,
					login_password: this.state.login_password,
				}).then((response: {
					status: number
					, data: {
						bookmarks_str: string
						, email: string
						, first_name: string
						, last_name: string
						, max_no_entries: string
						, options: string
						, place_names_arr: string //Array<any>
						, user_type: string
						, token: string
					}
				}) => {
					document.getElementById('login_error').style.display = 'none';
					document.getElementById('verify_email_error').style.display = 'none';
					this.handleClose();
					// alert(window.location.href)
					if (response.status === 200) {
						let bookmarksCount = 0;
						if (response.data.bookmarks_str) {
							const bookmarksArr = response.data.bookmarks_str.split(',');
							bookmarksCount = bookmarksArr.length;
						}
						localStorage.setItem('bookmarks', response.data.bookmarks_str);
						localStorage.setItem('listingNames', response.data.place_names_arr);
						localStorage.setItem('maxNoEntries', response.data.max_no_entries);
						localStorage.setItem('membershipOptions', response.data.options);

						if (response.data.user_type === 'admin') {
							this.setState({
								showOTPModal: true
							});
						} else {
							this.handleLoginSuccessResponse(response);
						}
					} else {
						this.setState({ isLoggedIn: false });
						if (response.status === 204) {
							document.getElementById('verify_email_error').style.display = 'block';
							document.getElementById('verify_email_error').scrollIntoView({ behavior: 'smooth' });
						} else {
							document.getElementById('login_error').style.display = 'block';
							document.getElementById('login_error').scrollIntoView({ behavior: 'smooth' });
						}
					}
				}).catch((error) => {
					// handle your error
					const errorEl = document.getElementById('login_error');
					if (errorEl) {
						errorEl.style.display = 'block';
						errorEl.scrollIntoView({ behavior: 'smooth' });
					}
				});
		} else {
			this.loginValidator.showMessages();
			// rerender to show messages for the first time
			// you can use the autoForceUpdate option to do this automatically`
			this.forceUpdate();
		}
	}

	handleLoginSuccessModal() {
		this.setState({ showLoginSuccessModal: false });
	}

	showRegistrationModal = () => {
		gtag('event', 'home-reg-click', {poll_title: 'home-reg-click', })
		this.setState({
			showRegistrationModal: true,
			showLoginModal: false,
		});
	}

	handleRegistrationModal = () => {
		this.setState({ showRegistrationModal: false });
	}

	setFName(event) {
		this.setState({ fname: event.target.value });
	}

	setLName(event) {
		this.setState({ lname: event.target.value });
	}

	setCompanyName(event) {
		this.setState({ companyName: event.target.value });
	}

	setPassword(event) {
		this.setState({ password: event.target.value });
	}

	setConfirmPassword(event) {
		this.setState({ confirm_password: event.target.value });
	}

	setEmail(event) {
		this.setState({ email: event.target.value });
	}

	onRecaptchaChange(value) {
		this.setState({ reacatpcha_value: value });
	}

	registerUser(event) {
		if (this.validator.allValid()) {
			LinkedInTag.track('9791956');
			axios.post(process.env.REACT_APP_BASE_URL + '/api/register-user',
				{
					headers: { 'Content-Type': 'application/json' },
					fname: this.state.fname,
					lname: this.state.lname,
					email: this.state.email,
					companyName: this.state.companyName,
					password: this.state.password,
					reacatpcha_value: this.state.reacatpcha_value,
				}).then(response => {
					// handle your response;
					if (response.status === 200) {
						this.setState({
							fname: '',
							lname: '',
							companyName: '',
							password: '',
							confirm_password: '',
							email: '',
							reacatpcha_value: null,
							showRegistrationSuccessModal: true,
							showRegistrationModal: false
						});
					}
				}).catch((error) => {
					// handle your error
					const regi_errors = document.getElementById('regi_errors');
					regi_errors.innerHTML = '';
					const error_html = document.createElement('div');
					if (error.response.status === 600 && error.response.data.error === 'email exists') {
						error_html.innerHTML = 'You already have an account, please login!';
					} else if (error.response.status === 601) {
						error_html.innerHTML = 'Captcha verification failed, please try again!';
					} else {
						for (let i = 0; i < error.response.data.errors.length; i++) {
							error_html.innerHTML += error.response.data.errors[i].msg + '<br>';
						}
					}
					document.getElementById('regi_errors').appendChild(error_html);
					document.getElementById('regi_errors').classList.add('alert', 'alert-danger', 'display-block');
					regi_errors.scrollIntoView({ behavior: 'smooth' })
				});
		} else {
			this.validator.showMessages();
			this.forceUpdate();
		}
	}

	handleRegistrationSuccessModal = () => {
		this.setState({ showRegistrationSuccessModal: false });
	}

	handleOTPModal = () => {
		this.setState({ showOTPModal: false });
	}

	handleInputChange = (name, value) => {
		this.setState({ [name]: value });
	}

	handleOTPVerification = () => {
		if (this.OTPValidator.allValid()) {
			axios.post(process.env.REACT_APP_BASE_URL + '/api/verify-otp',
				{
					headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
					otp: this.state.otp,
					login_email: this.state.login_email,
				}).then(response => {
					if (response.status === 200) {
						this.handleOTPModal();
						this.handleLoginSuccessResponse(response);
					}
				}).catch(function (error) {
					// handle your error
				});
		} else {
			this.OTPValidator.showMessages();
			this.forceUpdate();
		}
	}


	render() {
		const isLoggedIn = UserProfile.getEmail();
		return (
			<React.Fragment>
				<nav className='navbar navbar-default visible-xs-custom margin-bottom-0' style={{ zIndex: 999, top: 0, position: 'fixed', width: '100%', fontFamily: 'Roboto, sans-serif', background: 'white', opacity: 1, boxShadow: '0px 0px 30px 0px rgb(0 0 0 / 10%)' }} >
					<div className='container-fluid'>
						<div className='navbar-header float-none' >
							<button type='button' style={{ width: 50 }} className='navbar-toggle navbar-toggle-custom collapsed' data-toggle='collapse' data-target='#navbar' aria-expanded='false' aria-controls='navbar'>
								<span className='sr-only'>Toggle navigation</span>
								<span className='icon-bar'></span>
								<span className='icon-bar'></span>
								<span className='icon-bar'></span>
							</button>
							<Link className='img-responsive' style={{ height: 35, paddingLeft: 10, marginTop: 10 }} to={{ pathname: '/' }}><img style={{ height: '100%' }} src={logo} alt='logo' /></Link>
						</div>
						<div id='navbar' className='navbar-collapse collapse background-white nav-collapse-custom' aria-expanded='false'>
							<ul className='nav navbar-nav' role="menu" style={{ width: "100%" }}>

								<li className='text-black'><Link onClick={() => this.props.data.history.push('/')} className='text-black font-size-17 font-weight-500 font-family-montserrat header-hover'>Home</Link></li>
								<li className='text-black'><Link onClick={() => this.props.data.history.push('/about-us')} className='text-black font-size-17 font-weight-500 font-family-montserrat header-hover'>About Us</Link></li>

								<li className='text-black'>
									<Link className="dropdown-toggle text-black font-size-17 font-weight-500 font-family-montserrat dropdown" type="button" data-toggle="dropdown">Solutions
										<span className="caret"></span></Link>
									<ul className="dropdown-menu" role="menu">
										<li><a style={{ color: '#4a4a4a' }} className="dropdown-item" onClick={() => this.props.data.history.push('/searcher')} >For Searchers</a></li>
										<li><a style={{ color: '#4a4a4a' }} className="dropdown-item" onClick={() => this.props.data.history.push('/lister')} >For Listers</a></li>
										<li><a style={{ color: '#4a4a4a' }} className="dropdown-item" onClick={() => this.props.data.history.push('/private-clients-info')} >Private Label</a></li>
									</ul>
								</li>
								<li><Link onClick={() => this.props.data.history.push('/plans-and-pricing')} className='text-black font-size-17 font-weight-500 font-family-montserrat header-hover'>Plans and Pricing</Link></li>
								<li><Link onClick={() => this.props.data.history.push('/view-listings')} className='text-black font-size-17 font-weight-500 font-family-montserrat header-hover'>View Listings</Link></li>
								<li><Link onClick={() => this.props.data.history.push('/create-listings')} className='text-black font-size-17 font-weight-500 font-family-montserrat header-hover'>Create Listings</Link></li>
								<li><Link onClick={() => window.location.href = "https://insights.industrialnavigator.com"} className='text-black font-size-17 font-weight-500 font-family-montserrat hover'>Insights Blog</Link></li>
								<li className='' style={{ display: 'inline-block', padding: '15px 15px 15px 0px', float: "left" }}><a style={{ padding: 10, color: 'black' }} href="https://twitter.com/IndNavigator" target='_blank' className="nav-item"><i className="fa fs-30 fa-twitter"></i></a></li>
								<li className='row' style={{ display: 'inline-block', padding: '15px 15px 15px 0px', float: "left" }}><a style={{ padding: 10, color: 'black' }} href="https://www.linkedin.com/showcase/industrial-navigator%C2%AE/?viewAsMember=true" target='_blank' className="nav-item"><i className="fa fs-30 fa-linkedin"></i></a></li>
									
								
								{isLoggedIn ? (
									<React.Fragment>

										<li className='row' style={{ display: 'inline-block', padding: '15px 15px 15px 15px', float: "left" }}><a style={{ padding: 10 }} className="nav-item login iq-button iq-btn-outline iq-btn-round" onClick={this.logoutUser}>Logout</a>
										</li>
										<li className='' style={{ display: 'inline-block', padding: '15px 15px 15px 15px', float: "left" }}><a style={{ padding: 10 }} className="nav-item login iq-button iq-btn-outline iq-btn-round" onClick={this.handleMyListing}>
											
											<div >Admin</div>
										</a></li>
									</React.Fragment>
								) : (
									<React.Fragment>
										<li className='' style={{ display: 'inline-block', padding: '15px 15px 15px 15px', float: "left" }}><a style={{ padding: 10, color: 'black' }} className="nav-item login iq-button iq-btn-outline iq-btn-round" onClick={this.handleShow.bind(this, '', '', '')}>Login</a></li>
										<li className='row' style={{ display: 'inline-block', padding: '15px 15px 15px 15px', float: "left" }}><a style={{ padding: 9, backgroundColor: 'rgb(0, 123, 252)', }} className="nav-item  iq-button default iq-btn-round" onClick={this.showRegistrationModal}><div style={{ padding: 3, color: 'white' }}>Sign Up</div></a></li>
									</React.Fragment>
								)}
							</ul>
						</div>
					</div>
				</nav>
				<nav className='navbar hidden-xs-custom margin-bottom-0' style={{ paddingLeft: 50, paddingRight: 50, background: 'white', opacity: 1, boxShadow: '0px 0px 30px 0px rgb(0 0 0 / 10%)', position: 'fixed', left: 0, right: 0, top: -1, zIndex: 999, fontFamily: 'Roboto, sans-serif' }}>
					<div style={{ position: 'absolute', left: 0, height: '100%', right: 0, background: 'ffffff', opacity: 0.7 }}></div>
				
					<div >
						<div style={{ paddingRight: 0 }} className='col-lg-12 col-md-12'>
							<div className='col-lg-2 col-md-2 pull-left' style={{ paddingTop: 10, paddingLeft: 0, zIndex: 999 }}>
								<Link className='img-responsive' style={{ height: 35, paddingLeft: 0, marginTop: 10 }} to={{ pathname: '/' }}><img style={{ height: '100%' }} src={logo} alt='logo' /></Link>
							</div>
							<div className='col-lg-7 col-md-7 text-center' style={{}}>
								<ul style={{ marginBottom: 0 }}>
									{/* <li style={{ display: 'inline-block', padding: '22.5px 15px 22.5px 15px', fontSize: 14 }}><Link style={{ color: '#4a4a4a' }} to={{ pathname: '/about-us' }} className=' nav-item'>About Us</Link></li> */}
									<li style={{ display: 'inline-block', padding: '22.5px 10px 22.5px 10px', fontSize: 14 }}>
										<Link style={{ color: '#4a4a4a' }} to={{ pathname: '/about-us' }} className=' nav-item'>About Us</Link></li>
									<li style={{ display: 'inline-block', padding: '22.5px 10px 22.5px 10px', fontSize: 14 }}>
										<div className="dropdown">
											<Link style={{ color: '#4a4a4a' }} className="dropdown-toggle" type="button" data-toggle="dropdown">Solutions
												<span className="caret"></span></Link>
											<ul className="dropdown-menu">
												<li><a style={{ color: '#4a4a4a' }} className="dropdown-item" href="/searcher">For Searchers</a></li>
												<li><a style={{ color: '#4a4a4a' }} className="dropdown-item" href="/lister">For Listers</a></li>
												<li><a style={{ color: '#4a4a4a' }} className="dropdown-item" href="/private-clients-info">Private Label</a></li>
											</ul>
										</div>
									</li>

									<li style={{ display: 'inline-block', padding: '22.5px 10px 22.5px 10px', fontSize: 14 }}><Link style={{ color: '#4a4a4a' }} to={{ pathname: '/plans-and-pricing' }} className=' nav-item'>Plans and Pricing</Link></li>
									<li style={{ display: 'inline-block', padding: '22.5px 10px 22.5px 10px', fontSize: 14 }}><Link style={{ color: '#4a4a4a' }} to={{ pathname: '/view-listings' }} className=' nav-item'>View Listings</Link></li>
									<li style={{ display: 'inline-block', padding: '22.5px 10px 22.5px 10px', fontSize: 14 }}><Link style={{ color: '#4a4a4a' }} to={{ pathname: '/create-listings' }} className=' nav-item'>Create Listings</Link></li>
									<li style={{ display: 'inline-block', padding: '22.5px 10px 22.5px 10px', fontSize: 14 }}><a style={{ color: '#4a4a4a' }} href='https://insights.industrialnavigator.com/' className=' nav-item'>Insights Blog</a></li>

									<li style={{ display: 'inline-block', padding: '22.5px 10px 22.5px 10px', fontSize: 14 }}><a style={{ color: '#4a4a4a' }} href="https://twitter.com/IndNavigator" target='_blank' className='nav-item'><i className="fa fs-20 fa-twitter"></i></a></li>
									<li style={{ display: 'inline-block', padding: '22.5px 10px 22.5px 10px', fontSize: 14 }}><a style={{ color: '#4a4a4a' }} href="https://www.linkedin.com/showcase/industrial-navigator%C2%AE/?viewAsMember=true" target='_blank' className='nav-item'><i className="fa fs-20 fa-linkedin"></i></a></li>
									
								</ul>

							</div>
							<div className='col-lg-3 col-md-3 pull-right' style={{ paddingTop: 10, paddingLeft: 0, paddingRight: 0, zIndex: 999 }}>
								{isLoggedIn ? (
									<React.Fragment>
										<li style={{ display: 'inline-block', padding: '5px 5px 10px 20px', fontSize: 16, float: 'right' }} className="d-inline"><a style={{ border: '2px solid rgb(0, 157, 245)' }} className="nav-item signup iq-button default iq-btn-round" onClick={this.logoutUser}>Logout</a></li>
										<li style={{ display: 'inline-block', padding: '5px 5px 10px 20px', fontSize: 16, float: 'right' }} className="d-inline"><a className="nav-item login iq-button iq-btn-outline iq-btn-round" onClick={this.handleMyListing}>Admin</a></li>

									</React.Fragment>
								) : (
									<React.Fragment>
										<li style={{ display: 'inline-block', padding: '5px 5px 10px 20px', fontSize: 16, float: 'right' }} className="d-inline"><a className="nav-item signup iq-button default iq-btn-round" onClick={this.showRegistrationModal}><div style={{ padding: 2 }}>Sign Up</div></a></li>
										<li style={{ display: 'inline-block', padding: '5px 5px 10px 20px', fontSize: 16, float: 'right' }} className="d-inline"><a className="nav-item login iq-button iq-btn-outline iq-btn-round" onClick={this.handleShow.bind(this, '', '', '')}>Login</a></li>

									</React.Fragment>
								)}
							</div>
						</div>
					</div>
				</nav>
				<nav className='navbar hidden-xs-custom-mid margin-bottom-0 ' style={{ paddingLeft: 30, zIndex: 999, paddingRight: 30, background: 'white', opacity: 1, boxShadow: '0px 0px 30px 0px rgb(0 0 0 / 10%)', position: 'fixed', left: 0, right: 0, top: -1, fontFamily: 'Roboto, sans-serif' }}>
					<div style={{ padding: 0 }} className='container'>
						<div style={{ padding: 0 }} className='col-lg-12 col-md-12'>
							<div className='col-lg-2 col-md-2 pull-left' style={{ padding: 0 }}>
								<Link className='img-responsive' style={{ height: 35, marginTop: 10 }} to={{ pathname: '/' }}><img style={{ height: '100%' }} src={logo} alt='logo' /></Link>
							</div>
							<div className='col-lg-7 col-md-7 text-center' style={{ paddingRight: 0 }}>
								<ul style={{ marginBottom: 0 }}>
									<li style={{ display: 'inline-block', padding: '22.5px 5px 22.5px 5px', fontSize: 14 }}><Link style={{ color: 'black' }} to={{ pathname: '/about-us' }} className=' nav-item'>About Us</Link></li>
									<li style={{ display: 'inline-block', padding: '22.5px 10px 22.5px 10px', fontSize: 15 }}>
										<div className="dropdown">
											<Link style={{ color: '#4a4a4a' }} className="dropdown-toggle" type="button" data-toggle="dropdown">Solutions
												<span className="caret"></span></Link>
											<ul className="dropdown-menu">
												<li><a style={{ color: '#4a4a4a' }} className="dropdown-item" href="/searcher">For Searchers</a></li>
												<li><a style={{ color: '#4a4a4a' }} className="dropdown-item" href="/lister">For Listers</a></li>
												<li><a style={{ color: '#4a4a4a' }} className="dropdown-item" href="/private-clients-info">Private Label</a></li>
											</ul>
										</div>
									</li>
									<li style={{ display: 'inline-block', padding: '22.5px 5px 22.5px 5px', fontSize: 14 }}><Link style={{ color: 'black' }} to={{ pathname: '/plans-and-pricing' }} className=' nav-item'>Plans and Pricing</Link></li>
									<li style={{ display: 'inline-block', padding: '22.5px 5px 22.5px 5px', fontSize: 14 }}><Link style={{ color: 'black' }} to={{ pathname: '/view-listings' }} className=' nav-item'>View Listings</Link></li>
									<li style={{ display: 'inline-block', padding: '22.5px 5px 22.5px 5px', fontSize: 14 }}><Link style={{ color: 'black' }} to={{ pathname: '/create-listings' }} className=' nav-item'>Create Listings</Link></li>
									<li style={{ display: 'inline-block', padding: '22.5px 5px 22.5px 5px', fontSize: 14 }}><a style={{ color: 'black' }} href='https://insights.industrialnavigator.com/' className='nav-item'>Insights Blog</a></li>

									<li style={{ display: 'inline-block', padding: '22.5px 5px 22.5px 5px', fontSize: 14 }}><a style={{ color: '#4a4a4a' }} href="https://twitter.com/IndNavigator" target='_blank' className='nav-item'><i className="fa fs-20 fa-twitter"></i></a></li>
									<li style={{ display: 'inline-block', padding: '22.5px 5px 22.5px 5px', fontSize: 14 }}><a style={{ color: '#4a4a4a' }} href="https://www.linkedin.com/showcase/industrial-navigator%C2%AE/?viewAsMember=true" target='_blank' className='nav-item'><i className="fa fs-20 fa-linkedin"></i></a></li>

								
								</ul>

							</div>
							<div className='col-lg-3 col-md-3 pull-right' style={{ padding: '5px 0px 5px 0px' }}>
								<ul style={{ marginTop: 15 }} className='margin-bottom-0 pull-right'>
									{isLoggedIn ? (
										<React.Fragment>
											{/* <li className='pull-right' style={{ display: 'inline-block', padding: '15px 15px 15px 15px' }}><Button className='font-Gotham-Pro-Medium' style={{ border: '2px solid rgba(255,255,255,0.75)', borderRadius: '0px !important', background: 'transparent', color: 'white', height: 50, width: 150 }} onClick={this.logoutUser}>LOGOUT</Button></li> */}
											<li style={{ display: 'inline-block', padding: '22.5px 5px 22.5px 5px', fontSize: 15 }} className="d-inline"><a className="nav-item signup iq-button iq-btn-outline iq-btn-round" onClick={this.handleMyListing}>
												{/* <li className='pull-right' style={{ display: 'inline-block', padding: '15px 15px 15px 15px' }}><Button className='font-Gotham-Pro-Medium' style={{ border: '2px solid rgba(255,255,255,0.75)', borderRadius: '0px !important', background: 'transparent', color: 'white', height: 50, width: 150 }} onClick={this.handleMyListing}> */}
												{
													UserProfile.getUserType('user_type') === 'admin'
														?
														<div >Admin</div>
														:
														<div >Admin</div>
												}
											</a></li>
											<li style={{ display: 'inline-block', padding: '22.5px 5px 22.5px 5px', fontSize: 15 }} className="d-inline"><a style={{ border: '2px solid rgb(0, 157, 245)' }} className="nav-item signup iq-button default iq-btn-round" onClick={this.logoutUser}>Logout</a></li>

										</React.Fragment>
									) : (
										<React.Fragment>
											{/* <li className='pull-right' style={{ display: 'inline-block', padding: '15px 15px 15px 15px' }}><Button className='font-Gotham-Pro-Medium' style={{ border: '2px solid rgba(255,255,255,0.75)', borderRadius: '0px !important', background: 'transparent', color: 'white', height: 50, width: 150 }} onClick={this.handleShow.bind(this, '', '', '')}>Login / Sign Up</Button></li> */}
											<li style={{ display: 'inline-block', padding: '22.5px 10px 22.5px 10px', fontSize: 16 }} className="d-inline"><a className="float-right nav-item login iq-button iq-btn-outline iq-btn-round" onClick={this.handleShow.bind(this, '', '', '')}>Login</a></li>
											<li style={{ display: 'inline-block', padding: '22.5px 10px 22.5px 10px', fontSize: 16 }} className="d-inline"><a style={{ border: '2px solid rgb(0, 157, 245)' }} className="nav-item signup iq-button default iq-btn-round" onClick={this.showRegistrationModal}>Sign Up</a></li>

										</React.Fragment>
									)}
								</ul>
							</div>
						</div>
					</div>
				</nav>
				<Modal show={this.state.showForgotPasswordModal} onHide={this.handleForgotPasswordClose} style={{ padding: '0px!important', opacity: 1 }}>
					<Modal.Header style={{ padding: 0 }} closeButton></Modal.Header>
					<Modal.Body style={{ backgroundColor: '#009df5' }}>
						<div>
							<div style={{ padding: '3rem' }}>
								<div style={{ backgroundColor: '#f8f9fa', padding: '1.5rem', borderRadius: 6 }}>
									<div style={{ width: 200, margin: '0 auto' }}>
										<img src={logo} />
									</div>
									<h2 className='text-center text-black font-size-30' style={{ paddingTop: '1rem' }}>
										Forgot Password
									</h2>
									<form style={{ width: '95%', marginLeft: '2%', marginRight: '2%', paddingBottom: 10 }} className='nobottommargin'>
										<div id='fp_error' className='alert alert-danger' style={{ display: 'none' }}>Your email address is not in our records. Please sign up again.</div>
										<div id='fp_success' className='alert alert-success' style={{ display: 'none' }}> Password link should be sent to your email address.</div>
										{/* <div className='input-group margin-top-15 col-lg-12'>
											<input type='email' name='fpEmail' className='input-lg not-dark required email' placeholder='Enter your Email..' onChange={this.setFPEmail} value={this.state.fpEmail} />
										</div> */}
										<input type='email' name='fpEmail' className='input-lg not-dark required email' placeholder='Enter your Email..' onChange={this.setFPEmail} value={this.state.fpEmail} />

										<div className='col_full center padding-top-20'>
											<button className='btn btn-default border-radius-25-imp' type='button' value='submit' onClick={this.sendFPEmail}>Submit</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</Modal.Body>
				</Modal>

				<Modal show={this.state.showNotificationModal} onHide={this.handleNotificationModal} style={{ padding: '0px!important', opacity: 1 }} animation={false}>
					<Modal.Header style={{ padding: 0 }} closeButton></Modal.Header>
					<Modal.Body style={{ background: 'white', padding: '1rem', marginBottom: '0px' }}>
						<div className='text-center' style={{ paddingTop: '1rem', paddingLeft: '3rem', paddingRight: '3rem' }}>
							<div className='event-type warning'>
								<div className='event-indicator '>
									<SVGIconNotification />
								</div>
							</div>
							<h2 className='text-black font-size-30 margin-bottom-10' style={{ textTransform: 'none', marginTop: 20 }}>
								Notification Update
							</h2>
							<p className='text-muted font-size-16-imp margin-bottom-0'>
								{this.state.notification_data}
							</p>
						</div>
					</Modal.Body>
					<Modal.Footer style={{ display: 'block', padding: '10px', borderTop: '1px solid #e9ecef' }}>
						<button className='btn btn-default border-radius-25-imp' type='button' value='submit' onClick={this.handleNotificationModal}>Close</button>
					</Modal.Footer>
				</Modal>

				<Modal dialogClassName='custom-modal modal-border' show={this.state.showLoginModal} onHide={this.handleClose} style={{ opacity: 1 }} animation={false}>
					<Modal.Header closeButton></Modal.Header>
					<Modal.Body>
						<div>
							<div style={{ padding: '1rem', backgroundColor: 'white' }}>
								<div style={{ backgroundColor: '#f8f9fa', padding: '1.5rem', borderRadius: 6 }}>
									<div style={{ width: 200, margin: '0 auto', marginBottom: 30 }}>
										<img src={logo} />
									</div>
									<form id='slider-subscribe-form' style={{ paddingBottom: '10px' }} className='nobottommargin'>
										<div className='text-center color-black font-size-18 margin-bottom-20' style={{ color: '#474747' }}>Enter email address and password to login</div>
										<div id='login_error' className='alert alert-danger' style={{ display: 'none' }}>Invalid email or password.</div>
										<div id='verify_email_error' className='alert alert-danger' style={{ display: 'none' }}>Please verify your email address for login.</div>
										<div style={{ width: "100%" }} className='input-group margin-top-15 col-lg-12'>
											<input type='email' name='login_email' className='form-control input-lg not-dark required email col-lg-12' placeholder='Enter your Email..' onChange={this.setLoginEmail} value={this.state.login_email} />
										</div>
										{this.loginValidator.message('email', this.state.login_email, 'required')}
										<div style={{ width: "100%" }} className='input-group margin-top-15 col-lg-12'>
											<input type='password' name='login_password' className='form-control input-lg not-dark required email' placeholder='Enter your Password..' onChange={this.setLoginPassword} value={this.state.login_password} />
										</div>
										{this.loginValidator.message('password', this.state.login_password, 'required')}
										<div className='col_full center padding-top-20'>
											<button className='btn btn-default border-radius-25-imp' type='button' name='template-contactform-submit' value='submit' onClick={this.handleLogin}>Sign In</button>
										</div>
										<div className='col_full center padding-top-20'>
											<span role='button' className='color-blue font-weight-bold' onClick={this.handleShowForgotPasswordModal}>Forgot Password?</span>
										</div>
									</form>
									<div style={{ paddingTop: '1rem' }}>
										<small>
											<div className='text-center text-black font-weight-bold'>
												Don't have an account? <span className='cursor-pointer color-blue' onClick={this.showRegistrationModal}>Sign Up</span></div>
										</small>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
				</Modal>

				<Modal show={this.state.showLoginSuccessModal} onHide={this.handleLoginSuccessModal.bind(this)} style={{ padding: '0px!important', opacity: 1 }} animation={false}>
					<Modal.Header style={{ padding: 0 }} closeButton></Modal.Header>
					<Modal.Body style={{ background: 'white', padding: '1rem', marginBottom: '0px' }}>
						<div className='text-center' style={{ paddingTop: '1rem', paddingLeft: '3rem', paddingRight: '3rem' }}>
							<div className='event-type info'>
								<div className='event-indicator '>
									<SVGIcon />
								</div>
							</div>
							<h2 className='text-black font-size-30 margin-bottom-10' style={{ textTransform: 'none' }}>
								Login Successful
							</h2>
						</div>
					</Modal.Body>
					<Modal.Footer style={{ display: 'block', padding: '10px', borderTop: '1px solid #e9ecef' }}>
						<button className='btn btn-default border-radius-25-imp' type='button' value='submit' onClick={this.handleLoginSuccessModal.bind(this)}>Close</button>
					</Modal.Footer>
				</Modal>

				<Modal show={this.state.showLogoutSuccessModal} onHide={this.handleLogoutSuccessModal} style={{ padding: '0px!important', opacity: 1 }} animation={false}>
					<Modal.Header style={{ padding: 0 }} closeButton></Modal.Header>
					<Modal.Body style={{ background: 'white', padding: '1rem', marginBottom: '0px' }}>
						<div className='text-center' style={{ paddingTop: '1rem', paddingLeft: '3rem', paddingRight: '3rem' }}>
							<div className='event-type info'>
								<div className='event-indicator '>
									<SVGIcon />
								</div>
							</div>
							<h2 className='text-black font-size-30 margin-bottom-10' style={{ textTransform: 'none' }}>
								Logout Successful
							</h2>
							<p className='text-muted font-size-16-imp margin-bottom-0'>
								You are logged out of the system
							</p>
						</div>
					</Modal.Body>
					<Modal.Footer style={{ display: 'block', padding: '10px', borderTop: '1px solid #e9ecef' }}>
						<button className='btn btn-default border-radius-25-imp' type='button' value='submit' onClick={this.handleLogoutSuccessModal.bind(this)}>Close</button>
					</Modal.Footer>
				</Modal>

				<Modal dialogClassName='custom-modal-step3' show={this.state.showRegistrationModal} onHide={this.handleRegistrationModal} style={{ opacity: 1 }} animation={false}>
					<Modal.Header style={{ padding: 0 }} closeButton></Modal.Header>
					<Modal.Body style={{ backgroundColor: '#009df5', padding: 5 }}>
						<div>
							<div>
								<div style={{ backgroundColor: '#f8f9fa', padding: '1.5rem', borderRadius: 6 }}>
									<div style={{ width: 200, margin: '30px auto' }}>
										<img src={logo} />
									</div>
									{/* <h2 className='text-center text-black font-size-30' style={{ paddingTop: '1rem' }}>
										Welcome to Industrial Navigator!
									</h2> */}
									<MultiStepRegistration />
									{/* <form id='slider-subscribe-form' style={{ width: '80%', marginLeft: '10%', paddingBottom: '10px' }} className='nobottommargin'>
										<div className='text-center color-black font-size-18 margin-bottom-20' style={{ color: '#474747' }}>Please enter your details below to register for Industrial Navigator.</div>

										<div id='regi_errors' className='margin-top-15'></div>

										<div className='input-group margin-top-15 col-lg-12'>
											<input type='text' name='fname' className='form-control input-lg not-dark required email' placeholder='Enter your First Name..' onChange={this.setFName.bind(this)} value={this.state.fname} />
										</div>
										{this.validator.message('first name', this.state.fname, 'required')}

										<div className='input-group margin-top-15 col-lg-12'>
											<input type='text' name='lname' className='form-control input-lg not-dark required email' placeholder='Enter your Last Name..' onChange={this.setLName.bind(this)} value={this.state.lname} />
										</div>
										{this.validator.message('last name', this.state.lname, 'required')}
										<div className='col-lg-12 col-md-12 col-sm-12 input-group margin-top-15'>
											<input type='text' name='companyName' className='form-control input-lg not-dark required email' placeholder='Enter your Company Name..' onChange={this.setCompanyName.bind(this)} value={this.state.companyName} />
										</div>
										{this.validator.message('company name', this.state.companyName, 'required')}
										<div className='col-lg-12 col-md-12 col-sm-12 input-group margin-top-15'>
											<input type='email' name='email' className='form-control input-lg not-dark required email' placeholder='Enter your Email Address..' onChange={this.setEmail.bind(this)} value={this.state.email} />
										</div>
										{this.validator.message('email', this.state.email, 'required')}
										<div className='col-lg-12 col-md-12 col-sm-12 input-group margin-top-15'>
											<input type='password' name='password' className='form-control input-lg not-dark required email' placeholder='Enter your Password..' onChange={this.setPassword.bind(this)} value={this.state.password} />
										</div>
										{this.validator.message('password', this.state.password, 'required')}
										<div className='col-lg-12 col-md-12 col-sm-12 input-group margin-top-15'>
											<input type='password' name='confrim-password' className='form-control input-lg not-dark required email' placeholder='Confirm Password..' onChange={this.setConfirmPassword.bind(this)} value={this.state.confirm_password} />
										</div>
										{this.validator.message('confirm_password', this.state.confirm_password, `required|in:${this.state.password}`, { messages: { in: 'Passwords need to match!' } })}
										<ReCAPTCHA
											ref={recaptchaRef}
											// size='invisible'
											className='margin-top-15'
											onChange={this.onRecaptchaChange.bind(this)}
											sitekey={process.env.REACT_APP_RECAPTCHA_TOKEN}
										/>
										{this.validator.message('captcha', this.state.reacatpcha_value, 'required')}
										<div className='col_full center padding-top-20'>
											<button className='button button-border button-circle t500 noleftmargin topmargin-sm background-blue-imp border-none-imp' type='button' name='template-contactform-submit' value='submit' onClick={this.registerUser.bind(this)}>Register</button>
										</div>
									</form> */}
									{/* <div style={{ paddingTop: '1rem' }}>
										<small>
											<div className='text-center text-black font-weight-bold'>
												Already have an account? <span className='cursor-pointer color-blue' onClick={this.checkIfLoginPage}>Sign In</span></div>
										</small>
									</div> */}
								</div>
							</div>
						</div>
					</Modal.Body>
				</Modal>

				<Modal show={this.state.showRegistrationSuccessModal} onHide={this.handleRegistrationSuccessModal.bind(this)} style={{ padding: '0px!important', opacity: 1 }} animation={false}>
					<Modal.Header style={{ padding: 0 }} closeButton></Modal.Header>
					<Modal.Body style={{ background: 'white', padding: '1rem', marginBottom: '0px' }}>
						<div className='text-center' style={{ paddingTop: '1rem', paddingLeft: '3rem', paddingRight: '3rem' }}>
							<div className='event-type info'>
								<div className='event-indicator '>
									<SVGIcon />
								</div>
							</div>
							<h2 className='text-black font-size-30 margin-bottom-10' style={{ textTransform: 'none' }}>
								Registration Successful
							</h2>
							<p className='text-muted font-size-16-imp margin-bottom-0'>
								Please verify your email address before adding a listing.
							</p>
						</div>
					</Modal.Body>
					<Modal.Footer style={{ display: 'block', padding: '10px', borderTop: '1px solid #e9ecef' }}>
						<button type='button' className='btn btn-default border-radius-25-imp' onClick={this.handleRegistrationSuccessModal.bind(this)}>Close</button>
					</Modal.Footer>
				</Modal>

				<Modal show={this.state.showOTPModal} onHide={this.handleOTPModal.bind(this)} style={{ padding: '0px!important', opacity: 1 }} animation={false}>
					<Modal.Header style={{ padding: 0 }} closeButton></Modal.Header>
					<Modal.Body style={{ backgroundColor: '#009df5' }}>
						<div>
							<div style={{ padding: '3rem' }}>
								<div style={{ backgroundColor: '#f8f9fa', padding: '1.5rem', borderRadius: 6 }}>
									<div style={{ width: 200, margin: '0 auto' }}>
										<img src={logo} />
									</div>
									<h2 className='text-center text-black font-size-30' style={{ paddingTop: '1rem' }}>
										Verify OTP
									</h2>
									<form style={{ width: '80%', marginLeft: '10%', paddingBottom: 10 }} className='nobottommargin'>
										<div id='otp_error' className='alert alert-danger' style={{ display: 'none' }}>Invalid email.</div>
										<div id='otp_success' className='alert alert-success' style={{ display: 'none' }}> Password link should be sent to your email address.</div>
										<InputBoxComponent type='number' min='0' name='otp' onHandleInputChange={this.handleInputChange} />
										{this.OTPValidator.message('otp', this.state.otp, 'required')}
									</form>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer style={{ display: 'block', padding: '10px', borderTop: '1px solid #e9ecef' }}>
						<button type='button' className='btn btn-default border-radius-25-imp' onClick={this.handleOTPVerification}>Verify</button>
						<button type='button' className='btn btn-default border-radius-25-imp' onClick={this.handleOTPModal.bind(this)}>Close</button>
					</Modal.Footer>
				</Modal>

			</React.Fragment>
		)
	}
}

export default HomePageHeader;

const SVGIcon = () => (
	<svg style={{ width: 60, height: 60 }} viewBox='0 0 24 24'>
		<path fill='#fff' d='M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' />
	</svg>
)
const SVGIconNotification = () => (
	<svg style={{ width: 60, height: 60 }} viewBox='0 0 24 24'>
		<path fill='#000000' d='M11,4.5H13V15.5H11V4.5M13,17.5V19.5H11V17.5H13Z' />
	</svg>
)

const SVGLogo = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		width='200'
		height='39'
		viewBox='0 0 200 39'
	>
		<defs>
			<path
				id='path-1'
				d='M0 12.553h6.78v20.339H0v-20.34zm20.339 0h6.78v20.339h-6.78v-20.34zm10.17-6.78h6.78v20.339h-6.78V5.772z'
			></path>
			<path
				id='path-2'
				d='M55.308 15.36V1.111h-3.624V15.36h3.624zm1.955 0h3.495V9.162a1.897 1.897 0 011.896-2.119c1.204 0 1.797.763 1.797 2.034v6.29h3.505v-7.04c0-2.597-1.372-4.137-3.821-4.137a3.39 3.39 0 00-3.407 2.25h-.069V4.379h-3.396v10.99-.009zm16.45.148a3.475 3.475 0 003.357-2.034h.059v1.885h3.485V.4H77.11v5.895h-.068a3.4 3.4 0 00-3.299-2.074c-2.734 0-4.423 2.133-4.423 5.619.003 3.525 1.668 5.668 4.394 5.668zm1.303-8.532c1.303 0 2.113 1.116 2.113 2.893 0 1.778-.81 2.882-2.113 2.882s-2.119-1.096-2.119-2.893c-.004-1.776.816-2.882 2.12-2.882zm18.02-2.607h-3.505v6.201a1.88 1.88 0 01-1.856 2.119c-1.145 0-1.837-.711-1.837-2.044v-6.28h-3.496v7.05a3.814 3.814 0 004.02 4.128 3.13 3.13 0 003.199-2.262h.069v2.074h3.406V4.37zm1.56 3.328c0 1.67 1.136 2.797 3.279 3.249l2.063.435c.879.187 1.215.444 1.215.898 0 .593-.594.947-1.57.947a1.616 1.616 0 01-1.847-1.312H94.34c.148 2.23 2.014 3.683 5.17 3.683 3.05 0 5.104-1.452 5.104-3.713 0-1.66-.928-2.548-3.12-3.012l-2.271-.474c-.848-.178-1.264-.484-1.264-.932 0-.583.583-.968 1.472-.968a1.454 1.454 0 011.688 1.294h3.203c-.02-2.251-1.886-3.664-4.847-3.664-2.993.004-4.878 1.39-4.878 3.57zm12.215-5.756v2.428h-1.472v2.59h1.471v5.391c0 2.153 1.115 3.031 3.94 3.031a7.135 7.135 0 001.54-.138v-2.488a4.81 4.81 0 01-.711.05 1.073 1.073 0 01-1.271-1.156V6.96h1.98V4.372h-1.985V1.943h-3.495l.003-.002zm6.99 13.418h3.496V9.553a2.13 2.13 0 012.33-2.39c.388-.007.773.06 1.136.198V4.359a2.917 2.917 0 00-.899-.138 2.594 2.594 0 00-2.597 2.212h-.069V4.37h-3.396v10.99zm8.078 0h3.505V4.37h-3.505v10.99zm1.747-11.898a1.73 1.73 0 10-1.797-1.728 1.742 1.742 0 001.797 1.728zm8.051 9.618c-.898 0-1.481-.435-1.481-1.136 0-.672.543-1.096 1.54-1.165l2.024-.138v.763a1.875 1.875 0 01-2.086 1.676h.003zm-1.235 2.429a3.688 3.688 0 003.269-1.728h.07v1.58h3.396V7.835c0-2.212-1.949-3.704-4.878-3.704-2.972 0-4.915 1.472-5.006 3.693h3.15a1.54 1.54 0 011.688-1.186 1.395 1.395 0 011.63 1.382v.633l-2.578.158c-2.873.178-4.453 1.313-4.453 3.367-.004 1.976 1.645 3.329 3.709 3.329h.003zm8.541-.149h3.495V.4h-3.495v14.96zM56.814 38.11v-11.5h.109l8.35 11.5h3.937V18.518h-4.727v11.39h-.108l-8.306-11.39h-3.977v19.591h4.724-.002zm27.128 0h5.295l-6.584-19.591h-6.096l-6.585 19.591h5.077l1.25-4.304h6.408l1.235 4.304zm-4.491-15.437h.108l2.172 7.55h-4.466l2.186-7.55zm19.7 15.437l6.246-19.591H99.94l-3.76 14.718h-.109l-3.782-14.718h-5.662l6.246 19.591h6.28zm11.99 0V18.518h-4.983v19.591h4.984zm19.878-8.282v-2.402h-8.39v3.42h3.584l-.014.3c-.135 1.968-1.71 3.298-3.964 3.298-2.865 0-4.711-2.348-4.711-6.231 0-3.814 1.67-6.028 4.491-6.028a3.806 3.806 0 013.87 2.797h4.928c-.503-3.992-4.06-6.802-8.814-6.802-5.92 0-9.558 3.746-9.558 10.1 0 6.436 3.639 10.17 9.68 10.17 5.58 0 8.896-3.27 8.896-8.622h.002zm13.415 8.282h5.295l-6.585-19.591h-6.096l-6.584 19.591h5.078l1.248-4.304h6.408l1.236 4.304zm-4.492-15.437h.109l2.173 7.55h-4.467l2.185-7.55zm17.502 15.437V22.536h5.43v-4.018h-15.847v4.018h5.43V38.11H157.445zm14.542-19.93c-5.932 0-9.68 3.898-9.68 10.141 0 6.244 3.734 10.128 9.68 10.128 5.933 0 9.667-3.882 9.667-10.128 0-6.245-3.741-10.141-9.674-10.141h.007zm0 4.046c2.783 0 4.603 2.361 4.603 6.095 0 3.72-1.82 6.083-4.603 6.083-2.796 0-4.602-2.362-4.602-6.083-.011-3.734 1.81-6.095 4.595-6.095h.007zm15.967.054h2.933a2.703 2.703 0 012.933 2.796 2.627 2.627 0 01-2.919 2.77h-2.947v-5.566zm0 8.974h2.58l3.353 6.856h5.594l-3.91-7.59a5.86 5.86 0 003.34-5.538c0-4.046-2.635-6.463-7.523-6.463h-8.42v19.591h4.981v-6.856h.005z'
			></path>
		</defs>
		<g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
			<g transform='translate(-130 -40)'>
				<g transform='translate(130 33)'>
					<g transform='translate(0 7)'>
						<path
							fill='#4DAFFF'
							fillRule='nonzero'
							d='M10.169 5.773H16.949V26.112H10.169z'
						></path>
						<g>
							<use fill='#053359' xlinkHref='#path-1'></use>
							<use fill='#FFF' xlinkHref='#path-1'></use>
						</g>
						<g>
							<use fill='#053359' xlinkHref='#path-2'></use>
							<use fill='#FFF' xlinkHref='#path-2'></use>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)


const FacebookSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='10'
		height='19'
		viewBox='0 0 10 19'
	>
		<g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
			<g fill='#FFF' transform='translate(-535 -3115)'>
				<g transform='translate(0 2840)'>
					<g transform='translate(530 274)'>
						<path d='M11.25 7.513V5.145c0-.654.56-1.184 1.25-1.184h1.25V1h-2.5C9.179 1 7.5 2.59 7.5 4.553v2.96H5v2.96h2.5v9.475h3.75v-9.474h2.5L15 7.514h-3.75z'></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

const TwitterSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='17'
		viewBox='0 0 20 17'
	>
		<g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
			<g fill='#FFF' transform='translate(-590 -3115)'>
				<g transform='translate(0 2840)'>
					<g transform='translate(530 274)'>
						<g transform='translate(60)'>
							<path d='M20 3.013a8.256 8.256 0 01-2.362.677 4.236 4.236 0 001.803-2.37 7.978 7.978 0 01-2.6 1.037A4.026 4.026 0 0013.846 1C11.576 1 9.75 2.928 9.75 5.29c0 .34.027.667.095.979-3.409-.174-6.425-1.883-8.452-4.487a4.472 4.472 0 00-.56 2.168c0 1.486.73 2.803 1.82 3.565A3.913 3.913 0 01.8 6.987v.047c0 2.084 1.421 3.816 3.285 4.214a3.921 3.921 0 01-1.075.142c-.263 0-.528-.016-.776-.074.531 1.7 2.039 2.948 3.831 2.988A8.01 8.01 0 010 16.075 11.177 11.177 0 006.29 18c7.545 0 11.67-6.538 11.67-12.206 0-.19-.006-.373-.015-.554A8.398 8.398 0 0020 3.013z'></path>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

const LinkedInSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='20'
		height='20'
		viewBox='0 0 20 20'
	>
		<g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
			<g fill='#FFF'>
				<path d='M15.033 6.312c4.194 0 4.967 2.764 4.967 6.352V20L15.857 20v-6.647c-.004-1.525-.098-3.39-2.155-3.39-2.156 0-2.486 1.684-2.486 3.425v6.611H7.074V6.647h3.978v1.82h.058c.553-1.049 1.906-2.155 3.923-2.155zm-10.556.335V20H.33V6.648h4.147zM2.402 0c1.325 0 2.4 1.076 2.401 2.402 0 1.325-1.075 2.424-2.401 2.424C1.076 4.826 0 3.728 0 2.402A2.402 2.402 0 012.402 0z'></path>
			</g>
		</g>
	</svg>
)